import React from 'react';
import ErrorBoundary from '@/views/storyboard/cell/ErrorBoundary';
import StoryboardCellInnerContent from '@/views/storyboard/cell/StoryboardCellInnerContent';
import {Chart, ChartQuery, ChartSettings} from '@/entities/chart';
import {ConnectDragPreview} from 'react-dnd';

interface StoryboardCellComponentProps {
    id: number;
    chartQuery: ChartQuery;
    chart: ChartSettings;
    writeAccess: boolean;
    deleteChart: (index: number) => void;
    onNewChartSave: (chartData: Chart, toIndex?: number) => void;
    modifyChart: (chartData: Chart) => void;
    moveChart: (dragIndex: number, hoverIndex: number) => void;
    onChartMove: () => void;
    isDragging: boolean;
    index: number;
    innerRef: React.MutableRefObject<HTMLDivElement>;
    connectDragPreview?: ConnectDragPreview;
    hasError?: boolean;
}

const StoryboardCellComponent = React.memo<StoryboardCellComponentProps>((props) => (
    <ErrorBoundary>
        <StoryboardCellInnerContent
            {...props}  
        />
    </ErrorBoundary>
));

export default StoryboardCellComponent;
